module.exports = __webpack_public_path__ + "static/media/portfolio-img4.7e0a1b63.jpg";